import PropTypes from 'prop-types';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

const Default = (colors) => {
  const { blue, cyan, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: blue[0],
      100: blue[1],
      200: blue[2],
      light: blue[3],
      400: blue[4],
      main: blue[5],
      dark: blue[6],
      700: blue[7],
      darker: blue[8],
      900: blue[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: '#FEF2F2',
      100: '#FEE2E2',
      light: '#FECACA',
      300: '#FCA5A5',
      400: '#F87171',
      main: '#EF4444',
      600: '#DC2626',
      dark: '#B91C1C',
      800: '#991B1B',
      darker: '#7F1D1D',
      contrastText
    },
    warning: {
      lighter: '#FFF7ED',
      100: '#FFEDD5',
      light: '#FED7AA',
      300: '#FDBA74',
      400: '#FB923C',
      main: '#F97316',
      600: '#EA580C',
      dark: '#C2410C',
      800: '#9A3412',
      darker: '#7C2D12',
      contrastText: greyColors[100]
    },
    info: {
      lighter: cyan[0],
      light: cyan[3],
      main: cyan[5],
      dark: cyan[7],
      darker: cyan[9],
      contrastText
    },
    success: {
      lighter: '#FFF7ED',
      100: '#D1FAE5',
      light: '#A7F3D0',
      300: '#6EE7B7',
      400: '#34D399',
      main: '#10B981',
      600: '#059669',
      dark: '#047857',
      800: '#065F46',
      darker: '#064E3B',
      contrastText
    },
    grey: greyColors
  };
};

Default.propTypes = {
  colors: PropTypes.object
};

export default Default;
